/*
 * Sentir cart drawer
 * -----------------------------------------------------------------------------
 * Vervangt de iCart-app. Alle winkelmandje-interactie gebeurt hier; er is geen
 * losse /cart pagina meer.
 *
 * De drawer rendert zichzelf opnieuw via de Section Rendering API, zodat alle
 * prijzen, kortingen en de voortgangsbalken door Liquid worden berekend en niet
 * in JavaScript worden nagebouwd. Shopify blijft dus de enige bron van waarheid
 * voor bedragen: wat de klant in de drawer ziet is wat de checkout rekent.
 */

(function () {
  'use strict';

  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const ROUTES = {
    add: (window.routes && window.routes.cart_add_url) || ROOT + 'cart/add',
    change: (window.routes && window.routes.cart_change_url) || ROOT + 'cart/change',
    update: (window.routes && window.routes.cart_update_url) || ROOT + 'cart/update',
    cart: ROOT + 'cart',
  };

  // Secties die na elke wijziging opnieuw gerenderd worden.
  const SECTIONS = [
    { id: 'cart-drawer', target: 'cart-drawer', source: 'cart-drawer' },
    { id: 'cart-badge', target: 'cart-badge', source: 'cart-badge' },
    { id: 'cart-icon-bubble', target: '#cart-icon-bubble', source: '.shopify-section' },
  ];

  /* Waarmee we onze eigen verzoeken herkennen in de onderschepper hieronder. */
  const OWN_REQUEST_HEADER = 'X-Sentir-Cart';

  function postConfig(body) {
    return {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        [OWN_REQUEST_HEADER]: '1',
      },
      body: JSON.stringify(
        Object.assign({}, body, {
          sections: SECTIONS.map((section) => section.id).join(','),
          sections_url: window.location.pathname,
        })
      ),
    };
  }

  function parseSection(html, selector) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.querySelector(selector);
  }

  /*
   * Klassen die de toestand van de drawer bijhouden en dus niet uit de verse
   * sectie mogen komen. Zonder deze uitzondering verdwijnt is-open bij elke
   * wijziging en klapt het winkelmandje dicht zodra je een aantal aanpast.
   */
  const STATE_CLASSES = ['is-open', 'is-busy', 'is-footer-collapsed'];

  /* Neemt class, hidden en data-attributen over van de nieuw gerenderde node. */
  function syncAttributes(target, source) {
    if (!source) return;

    const kept = STATE_CLASSES.filter((name) => target.classList.contains(name));
    target.className = source.className;
    kept.forEach((name) => target.classList.add(name));

    if (source.hasAttribute('hidden')) {
      target.setAttribute('hidden', '');
    } else {
      target.removeAttribute('hidden');
    }
    Array.from(source.attributes).forEach((attribute) => {
      if (attribute.name.indexOf('data-') === 0) target.setAttribute(attribute.name, attribute.value);
    });
  }

  /* --------------------------------------------------------------- anker --- */

  /*
   * Toevoegen vanuit een slider zet er een regel bij, en die duwt alles
   * eronder omlaag -- inclusief de slider waar de klant net stond te kiezen.
   * Dezelfde scrollTop terugzetten is dan niet dezelfde plek: het getal klopt,
   * het beeld niet.
   *
   * Daarom onthouden we bij zo'n toevoeging een ELEMENT in plaats van een
   * getal. Waar dat element stond ten opzichte van de bovenrand, daar komt het
   * terug. De klant blijft staan waar hij stond en kan meteen de volgende
   * kiezen -- wat het hele punt van een slider is.
   */
  const ANKERS = [
    '[data-cd-bundle]',
    '.cd-capsule__heading',
    '.cd-upsell:not(.cd-match__list)',
    '[data-cd-match]',
  ];

  let ankerVerzoek = null;
  let hangendAnker = null;

  function vraagAnker(node) {
    ankerVerzoek = node || null;
  }

  function ankerSleutel(node) {
    if (node.dataset && node.dataset.lineKey) {
      return '[data-line-key="' + node.dataset.lineKey + '"]';
    }

    for (let i = 0; i < ANKERS.length; i += 1) {
      if (node.matches(ANKERS[i])) return ANKERS[i];
    }

    return null;
  }

  function meetAnker() {
    const body = document.querySelector('.cart-drawer__body');
    const node = ankerVerzoek;
    ankerVerzoek = null;

    if (!body || !node || !body.contains(node)) return null;

    const sleutel = ankerSleutel(node);
    if (!sleutel) return null;

    return {
      sleutel: sleutel,
      top: node.getBoundingClientRect().top - body.getBoundingClientRect().top,
    };
  }

  function herstelAnker(anker) {
    const body = document.querySelector('.cart-drawer__body');
    if (!body || !anker) return;

    const node = body.querySelector(anker.sleutel);
    if (!node) return;

    const staat = node.getBoundingClientRect().top - body.getBoundingClientRect().top;
    const verschil = staat - anker.top;
    if (Math.abs(verschil) < 1) return;

    body.scrollTop += verschil;
  }

  /*
   * De tweede slider vult zichzelf pas na de render, en tot dat moment is hij
   * leeg en dus nul hoog. Kort daarvoor kan de browser onze scrollTop hebben
   * afgekapt omdat er nog niet genoeg te scrollen viel. Daarom zetten we het
   * anker daarna nog een keer recht.
   */
  document.addEventListener('sentir:match:rendered', () => {
    if (!hangendAnker) return;
    herstelAnker(hangendAnker);
    hangendAnker = null;
  });

  /* ------------------------------------------------------ naar boven vliegen -- */

  /*
   * De sliders staan onderaan, de lijst met producten erboven. Zonder iets
   * ertussen zie je alleen dat alles opschuift, en niet dat er iets bij komt.
   *
   * Dus gaat de foto van de kaart RECHT omhoog, de lijst in. Recht, want een
   * eerdere versie mikte op de nieuwe regel zelf; die staat links in het paneel,
   * en dan schiet de foto zijwaarts weg. Op een breed scherm leest dat als een
   * fout in plaats van als een beweging.
   *
   * Hij wacht ook niet meer op het antwoord van het mandje. Dat wachten was de
   * andere helft van het probleem: de beweging veranderde halverwege van doel
   * zodra het antwoord binnenkwam, met een sprong als gevolg -- en hoe die
   * eruitzag hing af van de verbinding. Nu staat de beweging op zichzelf en is
   * hij elke keer hetzelfde.
   */
  const VLIEG_DUUR = 520;
  const VLIEG_HOOGTE = 260;

  function vliegNaarMandje(bron) {
    const body = document.querySelector('.cart-drawer__body');
    if (!bron || !body || typeof bron.animate !== 'function') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const start = bron.getBoundingClientRect();
    if (!start.width || !start.height) return;

    /*
     * Tot bovenaan de lijst, maar niet verder dan dit. Staat de kaart diep
     * onderin, dan wordt de reis anders alleen maar lang zonder dat er iets
     * bijkomt om naar te kijken.
     */
    const rand = body.getBoundingClientRect();
    const omhoog = Math.min(start.top - rand.top - 8, VLIEG_HOOGTE);
    if (omhoog < 24) return;

    /*
     * Het hele fotovak klonen en niet alleen de <img> erin. Zo komen de ronde
     * hoeken, de achtergrond en de mix-blend-mode mee en ziet de foto in de
     * lucht er precies zo uit als op de kaart. Met een losse img was het een
     * ander plaatje dan het plaatje waar hij vandaan kwam.
     */
    const vlieger = bron.cloneNode(true);
    vlieger.classList.add('cart-flyer');
    vlieger.removeAttribute('href');
    vlieger.removeAttribute('id');
    vlieger.setAttribute('aria-hidden', 'true');
    vlieger.style.left = start.left + 'px';
    vlieger.style.top = start.top + 'px';
    vlieger.style.width = start.width + 'px';
    vlieger.style.height = start.height + 'px';

    /*
     * Naast de drawer hangen en niet erin: het paneel schuift met een transform
     * naar binnen, en binnen een transform rekent position: fixed niet meer
     * vanaf het venster. Het vlak eromheen is ook uitgezonderd van de vervaging
     * die over de rest van de pagina ligt.
     */
    const drawer = document.querySelector('cart-drawer');
    (drawer && drawer.parentNode ? drawer.parentNode : document.body).appendChild(vlieger);

    /*
     * Twee animaties op twee eigenschappen in plaats van een op allebei. Zo kan
     * de foto lang goed zichtbaar blijven en pas op het eind wegvallen, zonder
     * dat de tijdlijn van de beweging eronder hoeft te lijden.
     *
     * Eerst een tikje omlaag en groter: dat leest als indrukken voor het
     * loslaten, en het maakt het vertrek zichtbaar zonder dat het schokt.
     */
    const beweging = vlieger.animate(
      [
        { transform: 'translateY(0) scale(1)', easing: 'cubic-bezier(0.4, 0, 0.6, 1)' },
        {
          transform: 'translateY(0.5rem) scale(1.06)',
          offset: 0.16,
          /*
           * Vlot weg en dan afremmen, maar niet zo hard afremmen dat hij het
           * laatste stuk stilhangt. Nagemeten: op 60% van de tijd is 90% van
           * de weg afgelegd. Met easeOutQuint was dat 98%, en die laatste
           * tienden van een seconde zag je hem alleen nog wegvagen.
           */
          easing: 'cubic-bezier(0.3, 0.55, 0.4, 1)',
        },
        { transform: 'translateY(' + -omhoog + 'px) scale(0.52)' },
      ],
      { duration: VLIEG_DUUR, fill: 'forwards' }
    );

    vlieger.animate([{ opacity: 1 }, { opacity: 1, offset: 0.5 }, { opacity: 0 }], {
      duration: VLIEG_DUUR,
      fill: 'forwards',
    });

    function opruimen() {
      if (vlieger.parentNode) vlieger.parentNode.removeChild(vlieger);
    }

    beweging.onfinish = opruimen;
    /*
     * Vangnet. In een tabblad op de achtergrond loopt een animatie niet af, en
     * dan zou de foto over het mandje blijven hangen.
     */
    window.setTimeout(opruimen, VLIEG_DUUR + 400);
  }

  /*
   * Een re-render vervangt de hele inhoud van de drawer. Zonder deze twee
   * functies springt de klant terug naar boven en klapt een geopend paneel
   * dicht zodra hij een aantal aanpast.
   */
  function kiesBol(bol) {
    const groep = bol.closest('[data-pick-dots]');
    if (!groep) return;
    groep.querySelectorAll('[data-pick-variant]').forEach((ander) => {
      const aan = ander === bol;
      ander.classList.toggle('is-selected', aan);
      ander.setAttribute('aria-pressed', aan ? 'true' : 'false');
    });
    const kaart = bol.closest('.cd-capsule');
    const img = kaart && kaart.querySelector('[data-capsule-image]');
    if (img && bol.dataset.image) {
      img.src = bol.dataset.image;
      img.srcset = bol.dataset.image2x ? bol.dataset.image + ' 1x, ' + bol.dataset.image2x + ' 2x' : '';
    }
  }

  /* Zet de kleurkeuzes van voor de re-render terug, alleen als die kleur er nog is. */
  function herstelKleuren(gekozen) {
    if (!gekozen) return;
    document.querySelectorAll('[data-pick-dots]').forEach((groep) => {
      const variant = gekozen['bol:' + groep.dataset.pickDots];
      if (!variant) return;
      const bol = groep.querySelector('[data-pick-variant="' + variant + '"]');
      if (bol && !bol.classList.contains('is-selected')) kiesBol(bol);
    });
    document.querySelectorAll('[data-gift-variant], [data-capsule-variant], [data-upsell-variant]').forEach((select) => {
      const waarde = select.id && gekozen['select:' + select.id];
      if (!waarde || select.value === waarde) return;
      if (!Array.from(select.options).some((optie) => optie.value === waarde)) return;
      select.value = waarde;
      /* De foto wisselt mee via de gewone change-handler. */
      select.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function captureUiState() {
    const body = document.querySelector('.cart-drawer__body');
    const openToolToggle = document.querySelector('[data-cart-tool][aria-expanded="true"]');
    const drawer = document.querySelector('cart-drawer');

    return {
      scrollTop: body ? body.scrollTop : 0,
      openTool: openToolToggle ? openToolToggle.dataset.cartTool : null,
      // De segmenten krijgen na de render nieuwe elementen, die al op hun
      // eindbreedte staan. We onthouden de oude breedtes om alsnog te animeren.
      fillWidths: Array.from(document.querySelectorAll('.cart-tiers__segment-fill')).map(
        (node) => node.style.width
      ),
      tierQuantity: drawer ? parseInt(drawer.dataset.tierQuantity, 10) || 0 : 0,
      lineKeys: Array.from(document.querySelectorAll('[data-line-key]')).map(
        (node) => node.dataset.lineKey
      ),
      /*
       * De notitie slaat zichzelf op zodra je het veld verlaat; het
       * kortingsveld niet. Een verse sectie komt met een leeg veld, dus zonder
       * dit is een ingetypte code weg zodra je een aantal aanpast.
       */
      discountDraft: (() => {
        const field = document.querySelector('[name="discount"]');
        return field ? field.value : '';
      })(),
      anker: meetAnker(),
      /* De sliders schuiven terug naar hun begin bij een verse sectie. */
      sliderLinks: Array.from(document.querySelectorAll('.cd-upsell')).map(
        (lijst) => lijst.scrollLeft
      ),
      /*
       * De gekozen kleur in de aanbodkaarten en het cadeaublok. Een verse sectie
       * staat weer op de eerste kleur (zwart): zonder dit springt de keuze terug
       * zodra de klant iets anders in het mandje verandert, en voegt "Add" dan
       * zwart toe. Klanten meldden precies dat.
       */
      kleuren: (() => {
        const gekozen = {};
        document.querySelectorAll('[data-pick-dots]').forEach((groep) => {
          const bol = groep.querySelector('[data-pick-variant].is-selected');
          if (groep.dataset.pickDots && bol) gekozen['bol:' + groep.dataset.pickDots] = bol.dataset.pickVariant;
        });
        document.querySelectorAll('[data-gift-variant], [data-capsule-variant], [data-upsell-variant]').forEach((select) => {
          if (select.id) gekozen['select:' + select.id] = select.value;
        });
        return gekozen;
      })(),
    };
  }

  function restoreUiState(state) {
    if (!state) return;

    if (state.openTool) openTool(state.openTool);

    if (state.discountDraft) {
      const field = document.querySelector('[name="discount"]');
      /* Staat hij al als chip in het mandje, dan hoort hij niet in het veld. */
      const alreadyApplied = Array.from(document.querySelectorAll('[data-discount-remove]')).some(
        (button) => button.dataset.discountRemove.toLowerCase() === state.discountDraft.toLowerCase()
      );

      if (field && !field.value && !alreadyApplied) field.value = state.discountDraft;
    }

    const body = document.querySelector('.cart-drawer__body');
    if (body && state.scrollTop) body.scrollTop = state.scrollTop;

    document.querySelectorAll('.cd-upsell').forEach((lijst, i) => {
      const links = state.sliderLinks[i];
      if (links) lijst.scrollLeft = links;
    });

    herstelKleuren(state.kleuren);

    if (state.anker) {
      herstelAnker(state.anker);
      hangendAnker = state.anker;
      window.setTimeout(() => {
        hangendAnker = null;
      }, 2000);
    }

    animateProgress(state.fillWidths);
    celebrateMilestones(state.tierQuantity);
    markNewLines(state.lineKeys);
    updateScrollHint();
  }

  /*
   * Wijst erop dat er nog producten onder de rand staan. Verschijnt alleen als
   * er echt iets te scrollen valt, en verdwijnt zodra je onderaan bent — anders
   * wijst een pijltje naar niets.
   */
  function updateScrollHint() {
    const body = document.querySelector('.cart-drawer__body');
    if (!body) return;

    const remaining = body.scrollHeight - body.scrollTop - body.clientHeight;

    const hint = document.querySelector('[data-scroll-hint]');
    if (hint) hint.classList.toggle('is-visible', remaining > 24);

    /* Zet de schaduw onder de kop aan zodra er iets onder door schuift. */
    const drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.classList.toggle('is-scrolled', body.scrollTop > 4);

    updateFooterByScroll(body, remaining);
  }

  /*
   * Onderaan de lijst is alles gezien, dus mag het voetstuk vanzelf terugkomen.
   * En zodra je daarna weer omhoog gaat, hoort het weg te zijn: je bent klaar
   * met de knoppen en wilt weer overzicht. Wachten tot je helemaal bovenaan
   * bent duurde te lang -- dan heb je de halve lijst al langs de rand van het
   * voetstuk gelezen.
   *
   * We kijken naar de RICHTING waarin je scrolt en niet naar de stand alleen.
   * Dat is wat het rustig houdt: klap je het voetstuk zelf dicht terwijl je
   * onderaan staat, dan springt het niet meteen weer open.
   *
   * Uitklappen vraagt bovendien om een beweging naar beneden. Het inklappen
   * maakt de lijst namelijk hoger, en dan schuift de browser de laatste regels
   * terug in beeld -- een verschuiving die de onderrand opnieuw raakt. Zonder
   * die eis zou hij daar meteen weer opengaan, en heen en weer blijven klappen.
   */
  const OMHOOG_VOOR_INKLAPPEN = 24;

  let laatsteTop = null;
  let onderaanGeweest = false;
  let omhoogGeschoven = 0;

  function resetFooterScroll() {
    laatsteTop = null;
    onderaanGeweest = false;
    omhoogGeschoven = 0;
  }

  function updateFooterByScroll(body, remaining) {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || !drawer.classList.contains('is-open')) return;

    /* Valt er niets te scrollen, dan zeggen 'boven' en 'onder' niets. */
    if (body.scrollHeight - body.clientHeight < 24) {
      resetFooterScroll();
      return;
    }

    const top = body.scrollTop;

    /*
     * De eerste meting na het openen leggen we alleen vast: zonder een vorige
     * stand is er geen richting, en dan zou de eerste beweging de verkeerde
     * kant op kunnen worden gelezen.
     */
    if (laatsteTop === null) {
      laatsteTop = top;
      return;
    }

    const verschil = top - laatsteTop;
    laatsteTop = top;

    if (verschil > 0) {
      omhoogGeschoven = 0;
      if (remaining <= 24) {
        onderaanGeweest = true;
        setFooterCollapsed(false, { store: false, focus: false });
      }
      return;
    }

    if (verschil < 0) {
      /*
       * Optellen in plaats van per gebeurtenis kijken. Een muiswiel geeft grote
       * stappen, een touchpad tientallen kleine; met een drempel per stap zou
       * het op de een wel werken en op de ander niet.
       */
      omhoogGeschoven += -verschil;

      if (onderaanGeweest && omhoogGeschoven >= OMHOOG_VOOR_INKLAPPEN) {
        onderaanGeweest = false;
        setFooterCollapsed(true, { store: false, focus: false });
      }
    }
  }

  let scrollHintFrame = null;

  function queueScrollHint() {
    if (scrollHintFrame) return;
    scrollHintFrame = window.requestAnimationFrame(() => {
      scrollHintFrame = null;
      updateScrollHint();
    });
  }

  // Scroll bubbelt niet, maar is wel te vangen in de capture-fase. Dat is nodig
  // omdat het element bij elke re-render wordt vervangen.
  document.addEventListener('scroll', queueScrollHint, true);
  window.addEventListener('resize', queueScrollHint);

  /* Laat elk segment van de oude naar de nieuwe stand lopen. */
  function animateProgress(previousWidths) {
    if (!previousWidths || !previousWidths.length) return;

    const fills = Array.from(document.querySelectorAll('.cart-tiers__segment-fill'));
    if (fills.length !== previousWidths.length) return;

    let changed = false;

    fills.forEach((fill, index) => {
      const previous = previousWidths[index];
      const target = fill.style.width;
      if (previous === undefined || previous === target) return;

      changed = true;
      fill.style.transition = 'none';
      fill.style.width = previous;

      // Forceert een reflow, anders slaat de browser de tussenstap over.
      void fill.offsetWidth;

      fill.style.transition = '';
      fill.style.width = target;
    });

    if (!changed) return;

    const group = document.querySelector('.cart-tiers__segments');
    if (!group) return;

    group.classList.add('is-filling');
    window.setTimeout(() => group.classList.remove('is-filling'), 900);
  }

  /* De tredes staan op 2, 3 en 4 stuks, in die volgorde in de DOM. */
  const MILESTONE_QUANTITIES = [2, 3, 4];

  function celebrateMilestones(previousQuantity) {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    const currentQuantity = parseInt(drawer.dataset.tierQuantity, 10) || 0;
    if (currentQuantity <= previousQuantity) return;

    const steps = document.querySelectorAll('.cart-tiers__segment');

    steps.forEach((step, index) => {
      const threshold = MILESTONE_QUANTITIES[index];
      if (threshold === undefined) return;
      if (previousQuantity >= threshold || currentQuantity < threshold) return;

      step.classList.add('just-reached');
      window.setTimeout(() => step.classList.remove('just-reached'), 900);
    });
  }

  /* Alleen regels die er nog niet waren schuiven in beeld. */
  function markNewLines(previousKeys) {
    if (!previousKeys) return;

    document.querySelectorAll('.cd-item[data-line-key]').forEach((item) => {
      if (previousKeys.indexOf(item.dataset.lineKey) === -1) item.classList.add('is-new');
    });
  }

  function renderSections(sections) {
    if (!sections) return;

    const state = captureUiState();

    SECTIONS.forEach((section) => {
      const html = sections[section.id];
      if (!html) return;

      const target = document.querySelector(section.target);
      if (!target) return;

      const source = parseSection(html, section.source);
      if (!source) return;

      target.innerHTML = source.innerHTML;
      if (section.target === section.source) syncAttributes(target, source);
    });

    restoreUiState(state);
    document.dispatchEvent(new CustomEvent('sentir:cart:updated'));
  }

  /* --------------------------------------------------- kortingscode / notitie -- */

  function openTool(name) {
    document.querySelectorAll('[data-cart-tool]').forEach((toggle) => {
      const isTarget = toggle.dataset.cartTool === name;
      toggle.setAttribute('aria-expanded', String(isTarget));
    });

    document.querySelectorAll('[data-cart-tool-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.cartToolPanel !== name;
    });
  }

  function closeTools() {
    document.querySelectorAll('[data-cart-tool]').forEach((toggle) => {
      toggle.setAttribute('aria-expanded', 'false');
    });
    document.querySelectorAll('[data-cart-tool-panel]').forEach((panel) => {
      panel.hidden = true;
    });
  }

  /* ------------------------------------------- voetstuk in- en uitklappen -- */

  /*
   * De stand staat als klasse op <cart-drawer> zelf, niet op het voetstuk.
   * Dat element blijft bij een re-render staan -- alleen zijn inhoud wordt
   * vervangen -- dus de stand overleeft het aanpassen van een aantal. In
   * STATE_CLASSES staat hij erbij zodat syncAttributes hem niet wegpoetst.
   */
  const FOOTER_KEY = 'sentir:cart:footer-collapsed';

  /* Onder deze afstand is het een tik, erboven een veeg. */
  const GRIP_SWIPE_MIN = 24;

  function readFooterState() {
    try {
      return window.sessionStorage.getItem(FOOTER_KEY) === '1';
    } catch (error) {
      // Safari in privemodus gooit hier. Dan onthouden we het gewoon niet.
      return false;
    }
  }

  function storeFooterState(collapsed) {
    try {
      window.sessionStorage.setItem(FOOTER_KEY, collapsed ? '1' : '0');
    } catch (error) {
      /* zie readFooterState */
    }
  }

  /* De knop volgt de klasse, niet andersom. */
  function syncFooterToggle() {
    const drawer = document.querySelector('cart-drawer');
    const toggle = document.querySelector('[data-cart-collapse-toggle]');
    if (!drawer || !toggle) return;

    const collapsed = drawer.classList.contains('is-footer-collapsed');
    toggle.setAttribute('aria-expanded', String(!collapsed));

    const label = collapsed ? toggle.dataset.labelExpand : toggle.dataset.labelCollapse;
    if (label) toggle.setAttribute('aria-label', label);
  }

  /*
   * options.store: false laat de voorkeur van de klant met rust. Gebruikt door
   * het automatisch openklappen onderaan de lijst -- dat is geen keuze van de
   * klant, dus het mag zijn keuze voor ingeklapt niet overschrijven.
   *
   * options.focus: false laat de focus staan waar hij staat. Zonder dat zou een
   * automatische opening de cursor midden in het scrollen naar de greep trekken.
   */
  function setFooterCollapsed(collapsed, options) {
    const settings = options || {};
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    if (drawer.classList.contains('is-footer-collapsed') === collapsed) return;

    /*
     * Focus mag niet achterblijven in iets dat zo meteen visibility:hidden is.
     * De browser laat hem dan naar <body> vallen en de focusval van de drawer
     * raakt de weg kwijt.
     */
    if (collapsed) {
      const active = document.activeElement;
      if (active && active.closest('[data-cart-collapse]')) {
        const toggle = drawer.querySelector('[data-cart-collapse-toggle]');
        if (toggle) toggle.focus();
      }
    }

    drawer.classList.toggle('is-footer-collapsed', collapsed);
    /*
     * Klapt het voetstuk in (scrollen of de greep), dan gaan "Sustainable
     * options" en de kortingscode ook dicht. Anders staan ze bij het weer
     * uitklappen nog open en duwt het paneel de knop "Checkout" omlaag.
     */
    if (collapsed) closeTools();
    if (settings.store !== false) storeFooterState(collapsed);
    syncFooterToggle();

    /*
     * trapFocus onthoudt het eerste en laatste focuspunt op het moment van
     * openen (global.js:11-14). Door het klappen verdwijnen er knoppen en
     * links uit de tabvolgorde, dus die grenzen kloppen daarna niet meer.
     */
    if (settings.focus !== false && drawer.classList.contains('is-open') && typeof trapFocus === 'function') {
      const panel = drawer.querySelector('.cart-drawer__panel');
      if (panel) {
        if (typeof removeTrapFocus === 'function') removeTrapFocus();
        trapFocus(panel, drawer.querySelector('[data-cart-collapse-toggle]') || panel);
      }
    }
  }

  function toggleFooter() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    setFooterCollapsed(!drawer.classList.contains('is-footer-collapsed'));
  }

  /*
   * Na een re-render is de knop een vers element zonder de juiste aria-stand.
   * renderSections vuurt dit event af zodra hij klaar is.
   */
  document.addEventListener('sentir:cart:updated', syncFooterToggle);

  /* ---------------------------------------------------------------- drawer -- */

  class CartDrawer extends HTMLElement {
    constructor() {
      super();

      this.activeElement = null;

      /*
       * Vegen pakken we alleen aan de greep zelf. Begint het gebaar ergens
       * anders in het voetstuk, dan zit de klant waarschijnlijk een knop aan
       * te raken en moet die knop gewoon zijn werk doen.
       */
      let gripStartY = null;
      let gripSwiped = false;

      this.addEventListener('pointerdown', (event) => {
        if (!event.target.closest('[data-cart-collapse-toggle]')) return;
        gripStartY = event.clientY;
        gripSwiped = false;
      });

      this.addEventListener('pointercancel', () => {
        gripStartY = null;
      });

      this.addEventListener('pointerup', (event) => {
        if (gripStartY === null) return;

        const delta = event.clientY - gripStartY;
        gripStartY = null;
        if (Math.abs(delta) < GRIP_SWIPE_MIN) return;

        gripSwiped = true;
        setFooterCollapsed(delta > 0);
      });

      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-cart-collapse-toggle]')) {
          event.preventDefault();
          /*
           * Na een veeg stuurt de browser alsnog een klik. Zonder deze vlag
           * draait die de veeg meteen weer terug.
           */
          if (gripSwiped) {
            gripSwiped = false;
            return;
          }
          toggleFooter();
          return;
        }

        if (event.target.closest('[data-cart-drawer-close]')) {
          event.preventDefault();
          this.close();
          return;
        }

        // Alles buiten het paneel telt als "naast het winkelmandje klikken".
        if (!event.target.closest('.cart-drawer__panel')) this.close();
      });

      this.addEventListener('keyup', (event) => {
        if (event.key === 'Escape') this.close();
      });
    }

    connectedCallback() {
      /*
       * De stand van het voetstuk uit een eerdere pagina overnemen -- maar
       * alleen als de greep er is. Zet je hem uit in de theme editor terwijl
       * er nog een ingeklapte stand in het geheugen zit, dan zou het voetstuk
       * dicht blijven zonder knop om het weer open te krijgen.
       */
      if (readFooterState() && this.querySelector('[data-cart-collapse-toggle]')) {
        this.classList.add('is-footer-collapsed');
      }
      syncFooterToggle();

      if (window.location.hash === '#cart' || new URLSearchParams(window.location.search).get('cart') === 'open') {
        // Wacht tot de rest van de pagina staat, anders vecht de focus met andere scripts.
        window.setTimeout(() => this.open(), 350);
      }
    }

    get isOpen() {
      return this.classList.contains('is-open');
    }

    open(triggerElement) {
      if (triggerElement) this.activeElement = triggerElement;

      this.classList.add('is-open');
      this.setAttribute('data-open', 'true');
      lockScroll();

      /*
       * Elke keer opnieuw beginnen. Zonder dit onthoudt hij de rand van de
       * vorige keer en klapt het voetstuk bij het openen al in, terwijl de
       * klant nog niets heeft gescrold.
       */
      resetFooterScroll();

      const panel = this.querySelector('.cart-drawer__panel');
      window.setTimeout(() => {
        if (typeof trapFocus === 'function') {
          trapFocus(this, this.querySelector('[data-cart-drawer-close]') || panel);
        } else if (panel) {
          panel.focus();
        }
      }, 200);

      // Pas meten als het paneel echt in beeld staat; daarvoor is de hoogte nul.
      window.requestAnimationFrame(updateScrollHint);

      document.dispatchEvent(new CustomEvent('sentir:cart:opened'));
    }

    close() {
      if (!this.isOpen) return;

      this.classList.remove('is-open');
      this.removeAttribute('data-open');
      unlockScroll();

      if (typeof removeTrapFocus === 'function') {
        removeTrapFocus(this.activeElement);
      } else if (this.activeElement && this.activeElement.focus) {
        this.activeElement.focus();
      }

      this.activeElement = null;
      document.dispatchEvent(new CustomEvent('sentir:cart:closed'));
    }

    setBusy(isBusy) {
      this.classList.toggle('is-busy', Boolean(isBusy));
    }

    announce(message) {
      const region = this.querySelector('[data-cart-live-region]');
      if (region) region.textContent = message;
    }
  }

  /* Scroll lock die de scrollpositie behoudt, ook op iOS. */
  let savedScrollPosition = 0;

  function lockScroll() {
    savedScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    document.body.style.top = `-${savedScrollPosition}px`;
    document.body.classList.add('cart-drawer-open');

    /*
     * De blur ligt over de hele pagina en kost een flinke repaint. Zetten we
     * hem in hetzelfde frame als de slide, dan vechten die twee om dezelfde
     * frames en gaat de drawer schokkerig open. Twee frames later heeft de
     * slide zijn eerste beelden al staan.
     */
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        if (document.body.classList.contains('cart-drawer-open')) {
          document.body.classList.add('cart-drawer-blurred');
        }
      });
    });
  }

  function unlockScroll() {
    document.body.classList.remove('cart-drawer-open', 'cart-drawer-blurred');
    document.body.style.top = '';
    window.scrollTo(0, savedScrollPosition);
  }

  /* ------------------------------------------------------------------ api -- */

  /*
   * De meting die met iCart mee de deur uit ging. Klaviyo's "Added to Cart"
   * was nooit van het thema: iCart stuurde het bij elke toevoeging, en met
   * het uitzetten van die embed (4 aug 2026) viel de metric stil -- en
   * daarmee de Abandoned Cart-flow, die erop triggert. Vanaf nu stuurt de
   * drawer hem zelf, bij élke geslaagde toevoeging (productpagina, quiz,
   * bundelkiezer, sliders).
   *
   * De property-vorm is die van het oude iCart-event (Name, Brand, ProductID,
   * URL, Price, ImageURL, CompareAtPrice, $value), zodat filters in de flow
   * blijven kloppen. Klaviyo bewaart dit alleen voor bezoekers die het kent;
   * dat was onder iCart precies zo, dus de flow herneemt zijn oude gedrag.
   */
  function meldKlaviyoToevoeging(data) {
    try {
      /* /cart/add.js geeft {items:[...]} bij een items-body en het kale item
       * bij een formulier-body; allebei komen ze hier langs. */
      const items = Array.isArray(data && data.items) ? data.items : [data];
      items.forEach((item) => {
        if (!item || !item.product_id) return;
        const lading = {
          Name: item.product_title || item.title || '',
          Brand: item.vendor || 'Sentir Parfum',
          ProductID: item.product_id,
          URL: window.location.href,
          Price: (item.price || 0) / 100,
          ImageURL: item.image || (item.featured_image && item.featured_image.url) || '',
          CompareAtPrice: '',
          Quantity: item.quantity || 1,
          $value:
            (item.final_line_price !== undefined
              ? item.final_line_price
              : (item.price || 0) * (item.quantity || 1)) / 100,
        };
        if (window.klaviyo && typeof window.klaviyo.track === 'function') {
          window.klaviyo.track('Added to Cart', lading);
        } else if (window._learnq && typeof window._learnq.push === 'function') {
          window._learnq.push(['track', 'Added to Cart', lading]);
        }
      });
    } catch (fout) {
      /* Meten mag nooit de kassa raken. */
    }
  }

  const SentirCart = {
    get drawer() {
      return document.querySelector('cart-drawer');
    },

    open(triggerElement) {
      const drawer = this.drawer;
      if (drawer) drawer.open(triggerElement);
    },

    close() {
      const drawer = this.drawer;
      if (drawer) drawer.close();
    },

    /* Voegt toe aan het winkelmandje en opent de drawer. */
    add(body, options) {
      const settings = options || {};
      const drawer = this.drawer;
      if (drawer) drawer.setBusy(true);

      return fetch(ROUTES.add + '.js', postConfig(body))
        .then((response) => response.json())
        .then((data) => {
          if (data.status) {
            throw new Error(data.description || data.message || 'Could not add to cart');
          }
          renderSections(data.sections);
          meldKlaviyoToevoeging(data);

          // Een frame wachten zodat de nieuwe inhoud al staat voordat de slide
          // begint; anders vallen de opbouw en de beweging in hetzelfde frame.
          if (settings.openDrawer !== false) {
            window.requestAnimationFrame(() => this.open(settings.trigger));
          }

          const drawerAfter = this.drawer;
          if (drawerAfter) drawerAfter.announce('Added to your cart');
          return data;
        })
        .finally(() => {
          const drawerAfter = this.drawer;
          if (drawerAfter) drawerAfter.setBusy(false);
        });
    },

    /* Wijzigt het aantal van een regel. quantity 0 verwijdert de regel. */
    change(lineKey, quantity) {
      const drawer = this.drawer;
      if (drawer) drawer.setBusy(true);

      return fetch(ROUTES.change + '.js', postConfig({ id: lineKey, quantity: quantity }))
        .then((response) => response.json())
        .then((data) => {
          renderSections(data.sections);
          return data;
        })
        .finally(() => {
          const drawerAfter = this.drawer;
          if (drawerAfter) drawerAfter.setBusy(false);
        });
    },

    update(body) {
      const drawer = this.drawer;
      if (drawer) drawer.setBusy(true);

      return fetch(ROUTES.update + '.js', postConfig(body))
        .then((response) => response.json())
        .then((data) => {
          renderSections(data.sections);
          return data;
        })
        .finally(() => {
          const drawerAfter = this.drawer;
          if (drawerAfter) drawerAfter.setBusy(false);
        });
    },

    refresh() {
      return this.update({});
    },
  };

  /*
   * Wat er bij elke "Add" in een slider hoort: de foto laten vliegen en de
   * plek vasthouden. Staat hier bij elkaar zodat beide sliders het op dezelfde
   * manier doen -- de tweede bouwt zijn kaarten in cart-match-slider.js.
   */
  function houdPlaats(knop) {
    const kaart = knop.closest('.cd-capsule');
    if (!kaart) return;

    /*
     * De tweede slider zit in [data-cd-match]; zijn eigen lijst draagt ook
     * .cd-upsell, en die kan geen anker zijn -- daar zou geen sleutel bij horen
     * die na de render nog te vinden is.
     */
    vraagAnker(kaart.closest('[data-cd-match]') || kaart.closest('.cd-upsell') || kaart);
    vliegNaarMandje(kaart.querySelector('.cd-capsule__media'));
  }

  SentirCart.houdPlaats = houdPlaats;
  window.SentirCart = SentirCart;

  /* --------------------------------------------------------- line quantity -- */

  class QuantityStepper extends HTMLElement {
    constructor() {
      super();

      this.input = this.querySelector('[data-quantity-input]');
      this.timer = null;

      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-quantity-change]');
        if (!button) return;

        event.preventDefault();
        const delta = parseInt(button.dataset.quantityChange, 10);
        const next = Math.max(0, parseInt(this.input.value, 10) + delta);
        this.commit(next);
      });

      this.addEventListener('change', (event) => {
        if (!event.target.matches('[data-quantity-input]')) return;
        const next = Math.max(0, parseInt(event.target.value, 10) || 0);
        this.commit(next);
      });
    }

    /*
     * Het nieuwe aantal staat er meteen, en pas daarna gaat het naar Shopify.
     * Wie drie keer snel op + tikt stuurt zo één verzoek in plaats van drie,
     * en ziet ondertussen geen haperende teller.
     */
    commit(quantity) {
      const lineKey = this.dataset.lineKey;
      const row = this.closest('.cd-item');

      this.input.value = quantity;
      window.clearTimeout(this.timer);

      if (quantity === 0) {
        removeLine(lineKey, row);
        return;
      }

      if (row) row.classList.add('is-updating');

      this.timer = window.setTimeout(() => {
        SentirCart.change(lineKey, quantity);
      }, 300);
    }
  }

  /* Laat de regel eerst dichtvouwen en stuurt daarna pas de wijziging door. */
  function removeLine(lineKey, row) {
    if (!row) {
      SentirCart.change(lineKey, 0);
      return;
    }

    if (row.classList.contains('is-removing')) return;

    row.style.height = `${row.offsetHeight}px`;
    void row.offsetHeight;
    row.classList.add('is-removing');
    row.style.height = '0px';

    window.setTimeout(() => SentirCart.change(lineKey, 0), 260);
  }

  /* --------------------------------------------------------- discount code -- */

  class CartDiscountForm extends HTMLElement {
    constructor() {
      super();

      this.input = this.querySelector('[name="discount"]');
      this.error = this.querySelector('[data-discount-error]');

      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-discount-apply]')) {
          event.preventDefault();
          this.apply();
        }

        const removeButton = event.target.closest('[data-discount-remove]');
        if (removeButton) {
          event.preventDefault();
          this.remove(removeButton.dataset.discountRemove);
        }
      });

      this.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' && event.target === this.input) {
          event.preventDefault();
          this.apply();
        }
      });
    }

    /* Bestaande codes blijven staan; Shopify verwacht de volledige lijst. */
    currentCodes() {
      return Array.from(this.querySelectorAll('[data-discount-remove]')).map(
        (button) => button.dataset.discountRemove
      );
    }

    showError(message) {
      if (!this.error) return;
      this.error.textContent = message;
      this.error.hidden = !message;
    }

    apply() {
      const code = (this.input.value || '').trim();
      if (!code) return;

      this.showError('');

      const codes = this.currentCodes();
      if (codes.some((existing) => existing.toLowerCase() === code.toLowerCase())) {
        this.showError('This code has already been applied.');
        return;
      }

      codes.push(code);

      /* Zet de code terug in het veld als hij niet is aangekomen. */
      const putBack = (message) => {
        openTool('discount');
        const form = document.querySelector('cart-discount-form');
        if (!form) return;

        form.showError(message);
        const input = form.querySelector('[name="discount"]');
        if (input) input.value = code;
      };

      /*
       * Het veld nu al leegmaken. captureUiState bewaart de inhoud ervan over
       * de re-render heen; blijft de code staan, dan komt hij naast zijn eigen
       * chip te staan en plakt hij aan de volgende code die iemand intypt.
       */
      this.input.value = '';

      SentirCart.update({ discount: codes.join(',') })
        .then(() => {
          // De sectie is opnieuw gerenderd; staat de code niet in de nieuwe
          // lijst, dan heeft Shopify hem afgewezen.
          const applied = Array.from(document.querySelectorAll('[data-discount-remove]')).some(
            (button) => button.dataset.discountRemove.toLowerCase() === code.toLowerCase()
          );

          if (!applied) putBack('This discount code is not valid for your cart.');
        })
        .catch(() => putBack('Something went wrong. Please try again.'));
    }

    remove(code) {
      const codes = this.currentCodes().filter((existing) => existing !== code);
      SentirCart.update({ discount: codes.join(',') });
    }
  }

  /* ------------------------------------------------------------------ note -- */

  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.textarea = this.querySelector('textarea');
      this.status = this.querySelector('[data-note-status]');
      this.timer = null;

      this.textarea.addEventListener('input', () => {
        window.clearTimeout(this.timer);
        if (this.status) this.status.textContent = '';
        this.timer = window.setTimeout(() => this.save(), 700);
      });

      this.textarea.addEventListener('blur', () => {
        window.clearTimeout(this.timer);
        this.save();
      });
    }

    save() {
      const note = this.textarea.value;

      // Geen volledige re-render: dat zou de cursor uit het veld gooien terwijl
      // de klant nog typt. De notitie verandert toch niets aan de prijzen.
      fetch(ROUTES.update + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: note }),
      })
        .then((response) => {
          if (!response.ok) throw new Error('save');
          if (this.status) this.status.textContent = 'Saved';
        })
        .catch(() => {
          if (this.status) this.status.textContent = 'Could not save';
        });
    }
  }

  /* ----------------------------------------------------------------- badge -- */

  class CartBadge extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-cart-drawer-open]');
        if (!button) return;
        event.preventDefault();
        SentirCart.open(button);
      });
    }
  }

  /* ------------------------------------------------------------ definities -- */

  if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawer);
  if (!customElements.get('quantity-stepper')) customElements.define('quantity-stepper', QuantityStepper);
  if (!customElements.get('cart-discount-form')) customElements.define('cart-discount-form', CartDiscountForm);
  if (!customElements.get('cart-note')) customElements.define('cart-note', CartNote);
  if (!customElements.get('cart-badge')) customElements.define('cart-badge', CartBadge);

  /* ------------------------------------------- toevoegen door andere apps -- */

  /*
   * Niet elke knop op de winkel is van het thema. De collectiepagina draait op
   * Searchanise, productpagina's soms op PageFly, en die voegen zelf toe aan
   * het winkelmandje. In plaats van per app een koppeling te maken luisteren we
   * op elk verzoek naar /cart/add: gaat er iets in het mandje buiten ons om,
   * dan halen we de drawer opnieuw op en openen hem.
   *
   * Onze eigen verzoeken dragen een header en worden overgeslagen; die
   * verversen zichzelf al.
   */
  const CART_ADD_URL = /\/cart\/add(\.js)?(\?|$)/;

  let externalAddTimer = null;

  function handleExternalAdd() {
    window.clearTimeout(externalAddTimer);
    externalAddTimer = window.setTimeout(() => {
      SentirCart.refresh().then(() => SentirCart.open());
    }, 150);
  }

  SentirCart.handleExternalAdd = handleExternalAdd;

  function headerValue(headers, name) {
    if (!headers) return null;
    if (typeof headers.get === 'function') return headers.get(name);
    const match = Object.keys(headers).find((key) => key.toLowerCase() === name.toLowerCase());
    return match ? headers[match] : null;
  }

  const nativeFetch = window.fetch;

  if (typeof nativeFetch === 'function') {
    window.fetch = function (input, init) {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      const isOwn =
        headerValue(init && init.headers, OWN_REQUEST_HEADER) ||
        (input && input.headers && headerValue(input.headers, OWN_REQUEST_HEADER));

      const result = nativeFetch.apply(this, arguments);

      // Nooit de oorspronkelijke promise vervangen of fouten opslokken.
      if (CART_ADD_URL.test(String(url)) && !isOwn) {
        result
          .then((response) => {
            if (response && response.ok) handleExternalAdd();
          })
          .catch(() => {});
      }

      return result;
    };
  }

  const nativeOpen = XMLHttpRequest.prototype.open;
  const nativeSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this.sentirIsCartAdd = CART_ADD_URL.test(String(url));
    return nativeOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    if (this.sentirIsCartAdd) {
      this.addEventListener('load', () => {
        if (this.status >= 200 && this.status < 300) handleExternalAdd();
      });
    }
    return nativeSend.apply(this, arguments);
  };

  /* --------------------------------------------------------- besteldeadline -- */

  function formatDuration(totalSeconds) {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return [hours, minutes, seconds].map((part) => String(part).padStart(2, '0')).join(':');
  }

  let refreshingDeadline = false;

  /*
   * Liquid geeft het aantal resterende seconden mee, berekend in de tijdzone van
   * de winkel. Hier wordt alleen afgeteld, dus een verkeerd ingestelde klok bij
   * de bezoeker verandert niets aan de belofte. Bij elke re-render komt er een
   * verse waarde binnen, waardoor de teller zichzelf corrigeert.
   */
  window.setInterval(() => {
    const clocks = document.querySelectorAll('[data-countdown]');
    if (!clocks.length) return;

    clocks.forEach((clock) => {
      const remaining = parseInt(clock.dataset.remaining, 10) - 1;

      if (remaining > 0) {
        clock.dataset.remaining = String(remaining);
        clock.textContent = formatDuration(remaining);
        return;
      }

      // De deadline is verstreken: Liquid moet een nieuwe dag en tijd leveren.
      clock.dataset.remaining = '0';
      clock.textContent = formatDuration(0);

      if (!refreshingDeadline) {
        refreshingDeadline = true;
        SentirCart.refresh().finally(() => {
          refreshingDeadline = false;
        });
      }
    });
  }, 1000);

  /* -------------------------------------------------------- globale clicks -- */

  document.addEventListener('click', (event) => {
    /* Regel verwijderen */
    const removeButton = event.target.closest('[data-line-remove]');
    if (removeButton) {
      event.preventDefault();
      removeLine(removeButton.dataset.lineRemove, removeButton.closest('.cd-item'));
      return;
    }

    /* Op het pijltje klikken scrollt de lijst een schermhoogte verder */
    const scrollButton = event.target.closest('[data-scroll-down]');
    if (scrollButton) {
      event.preventDefault();

      const body = document.querySelector('.cart-drawer__body');
      if (body) {
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        body.scrollBy({
          top: Math.round(body.clientHeight * 0.8),
          behavior: reduced ? 'auto' : 'smooth',
        });
      }
      return;
    }

    /* Het cadeau toevoegen, in de gekozen kleur */
    const giftButton = event.target.closest('[data-gift-add]');
    if (giftButton) {
      event.preventDefault();

      const blok = giftButton.closest('.cd-gift');
      const select = (blok && blok.querySelector('[data-gift-variant]')) || document.querySelector('[data-gift-variant]');
      const variantId = select ? select.value : giftButton.dataset.giftAdd;

      giftButton.disabled = true;
      SentirCart.add({ items: [{ id: Number(variantId), quantity: 1 }] }, { openDrawer: false }).catch(
        () => {
          giftButton.disabled = false;
        }
      );
      return;
    }

    /*
     * De hele bundel in één keer weg, inclusief het gratis reisformaat.
     *
     * Eén update met alle regels op nul, geen reeks losse verzoeken: dat zou
     * de klant net zo vaak laten wachten als er flacons zijn, en tussendoor
     * telkens een mandje opleveren waarin de staffelkorting alweer anders is.
     */
    const bundleRemove = event.target.closest('[data-bundle-remove]');
    if (bundleRemove) {
      event.preventDefault();

      const keys = (bundleRemove.dataset.bundleRemove || '').split(',').filter(Boolean);
      if (!keys.length) return;

      bundleRemove.disabled = true;

      const updates = {};
      keys.forEach((key) => {
        updates[key] = 0;
      });

      const card = bundleRemove.closest('[data-cd-bundle]');
      if (card) card.classList.add('is-removing');

      window.setTimeout(() => {
        SentirCart.update({ updates: updates }).catch(() => {
          bundleRemove.disabled = false;
          if (card) card.classList.remove('is-removing');
        });
      }, 260);
      return;
    }

    /* Nog een capsule, met korting, in de gekozen kleur */
    const capsuleButton = event.target.closest('[data-capsule-add]');
    if (capsuleButton) {
      event.preventDefault();

      const kaartCapsule = capsuleButton.closest('.cd-capsule');
      const gekozenBol = kaartCapsule && kaartCapsule.querySelector('[data-pick-variant].is-selected');
      const variantId = gekozenBol ? gekozenBol.dataset.pickVariant : capsuleButton.dataset.capsuleAdd;

      capsuleButton.disabled = true;
      houdPlaats(capsuleButton);

      /*
       * Koos de klant eerder "No twistcapsules" en neemt hij er nu toch een,
       * dan gaat die keuze eerst weer uit: anders zegt de pakbon "GEEN
       * twistcapsules meesturen" terwijl er een in de bestelling zit. Heeft hij
       * recht op de gratis capsule (data-capsule-gratis), dan komt die terug als
       * cadeau, zonder _capsule_upsell; anders als gewone extra capsule.
       */
      const gratis = capsuleButton.hasAttribute('data-capsule-gratis');
      const geenCapsules = document.querySelector('.cart-sustain__check[data-capsule-keys]');
      const keuzeUit =
        geenCapsules && geenCapsules.checked
          ? SentirCart.update({ attributes: { [geenCapsules.dataset.sustainAttr]: '' } })
          : Promise.resolve();

      const regel = { id: Number(variantId), quantity: 1 };
      /*
       * Merkt de regel voor de discount function. De underscore houdt hem uit
       * het zicht in mandje en checkout. De waarde zegt niets: hoeveel korting
       * het is beslist de function, anders zou de klant zijn eigen percentage
       * kunnen meesturen. Het kenmerk geeft de capsule ook een eigen regel, ook
       * als het cadeau dezelfde kleur heeft.
       */
      if (!gratis) regel.properties = { _capsule_upsell: '1' };

      keuzeUit
        .then(() => SentirCart.add({ items: [regel] }, { openDrawer: false }))
        .catch(() => {
          capsuleButton.disabled = false;
        });
      return;
    }

    /* Suggestie toevoegen vanuit "Past bij jouw set" */
    const upsellButton = event.target.closest('[data-upsell-add]');
    if (upsellButton) {
      event.preventDefault();
      upsellButton.disabled = true;
      houdPlaats(upsellButton);
      // Kaart met een kleurkiezer (pouch): de gekozen kleur, anders de voorgekozen variant.
      const kaart = upsellButton.closest('.cd-capsule');
      const kleurBol = kaart && kaart.querySelector('[data-pick-variant].is-selected');
      const upsellVariant = kleurBol ? kleurBol.dataset.pickVariant : upsellButton.dataset.upsellAdd;
      SentirCart.add(
        { items: [{ id: Number(upsellVariant), quantity: 1 }] },
        { openDrawer: false }
      ).catch(() => {
        upsellButton.disabled = false;
      });
      return;
    }

    /* Kortingscode- en notitiepaneel */
    const toolToggle = event.target.closest('[data-cart-tool]');
    if (toolToggle) {
      event.preventDefault();
      const isOpen = toolToggle.getAttribute('aria-expanded') === 'true';
      if (isOpen) {
        closeTools();
      } else {
        openTool(toolToggle.dataset.cartTool);
        const panel = document.querySelector(
          `[data-cart-tool-panel="${toolToggle.dataset.cartTool}"]`
        );
        const field = panel && panel.querySelector('input, textarea');
        if (field) field.focus();
      }
      return;
    }

    /* Elke link naar /cart opent voortaan de drawer. Er is geen cartpagina meer. */
    const cartLink = event.target.closest('a[href]');
    if (cartLink) {
      const href = cartLink.getAttribute('href') || '';
      const path = href.split('?')[0].split('#')[0].replace(/\/$/, '');
      const cartPath = ROUTES.cart.replace(/\/$/, '');

      if (path === cartPath && !cartLink.hasAttribute('data-allow-cart-page')) {
        event.preventDefault();
        SentirCart.open(cartLink);
        return;
      }
    }

    /* Alles met data-cart-drawer-open opent de drawer, waar het ook staat. */
    const opener = event.target.closest('[data-cart-drawer-open]');
    if (opener && !opener.closest('cart-badge')) {
      event.preventDefault();
      SentirCart.open(opener);
    }
  });

  /*
   * Kleur wisselen in het cadeau- of het capsuleblok: de foto springt mee. De
   * kleur is bij deze capsule het hele verschil, dus zonder dit kiest de klant
   * blind.
   *
   * Gedelegeerd op document, want beide blokken worden opnieuw opgebouwd zodra
   * het mandje verandert; een listener op het element zelf overleeft dat niet.
   */
  /*
   * Kleur van een regel wisselen (twistcapsule, pouch). Shopify kan de variant van een regel niet aanpassen, dus de
   * nieuwe kleur gaat erin (zelfde aantal, zelfde verborgen kenmerken zoals _capsule_upsell en _set_id) en daarna gaat
   * de oude regel eruit. Eerst toevoegen: mislukt dat (uitverkocht, netwerk), dan staat de oude regel er nog en is er
   * niets kwijt. De oude regel zoeken we daarna op in /cart.js op variant plus kenmerken, niet op zijn sleutel: die
   * sleutel verandert zodra de korting verschuift (de gratis capsule!). Gaat het weghalen mis, dan blijft er hooguit een
   * zichtbare extra regel staan.
   *
   * Zo rustig mogelijk: de foto wisselt meteen (zie de klik hieronder), het mandje dimt niet, de nieuwe regel komt
   * terug op de plek van de oude zonder inschuifanimatie, en de focus blijft bij de kleur. Eén wissel tegelijk.
   * Kale fetches en niet SentirCart.add: een kleurwissel is geen nieuwe toevoeging voor Klaviyo.
   */
  function leesKenmerken(raw) {
    let properties = {};
    try {
      properties = JSON.parse(raw || '{}') || {};
    } catch (fout) {
      properties = {};
    }
    // Liquid geeft de kenmerken als lijst van paren ([["_capsule_upsell","1"]], of [] zonder kenmerken);
    // /cart/add.js wil een object. Zonder deze omzetting verloor de extra capsule zijn 50% bij een kleurwissel.
    if (Array.isArray(properties)) {
      properties = properties.reduce((obj, paar) => {
        if (Array.isArray(paar) && paar.length === 2) obj[paar[0]] = paar[1];
        return obj;
      }, {});
    }
    return properties && typeof properties === 'object' ? properties : {};
  }

  function zelfdeKenmerken(a, b) {
    const ka = Object.keys(a || {}).filter((k) => a[k] !== '' && a[k] != null);
    const kb = Object.keys(b || {}).filter((k) => b[k] !== '' && b[k] != null);
    return ka.length === kb.length && ka.every((k) => String(a[k]) === String(b[k]));
  }

  let wisselBezig = false;

  function swapLineVariant(swatch, chosenId) {
    const oldVariantId = Number(swatch.dataset.variantId);
    const variantId = Number(chosenId);
    const quantity = Number(swatch.dataset.quantity) || 1;
    const properties = leesKenmerken(swatch.dataset.properties);

    const row = swatch.closest('.cd-item');
    const list = row ? row.parentNode : null;
    const plek = list ? Array.prototype.indexOf.call(list.children, row) : -1;
    const hadFocus = swatch.contains(document.activeElement);
    wisselBezig = true;
    swatch.classList.add('is-busy');
    if (row) row.classList.add('is-swapping');

    const vraag = (route, body) =>
      fetch(route + (body ? '.js' : ''), body
        ? {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest', [OWN_REQUEST_HEADER]: '1' },
            body: JSON.stringify(body),
          }
        : { headers: { Accept: 'application/json' } }
      ).then((response) => response.json().then((data) => {
        if (!response.ok || (data && data.status)) throw new Error((data && (data.description || data.message)) || 'Cart error');
        return data;
      }));
    const metHtml = (body) =>
      Object.assign({}, body, { sections: SECTIONS.map((section) => section.id).join(','), sections_url: window.location.pathname });

    // De nieuwe regel terug op de plek van de oude, zonder inschuiven, en de focus terug op de kleur.
    function terugOpZijnPlek(nieuweSleutel) {
      const el = nieuweSleutel ? document.querySelector('.cd-item[data-line-key="' + nieuweSleutel + '"]') : null;
      if (!el) return;
      el.classList.remove('is-new');
      if (plek >= 0) {
        const ouder = el.parentNode;
        const nu = Array.prototype.indexOf.call(ouder.children, el);
        if (nu !== plek) ouder.insertBefore(el, ouder.children[nu < plek ? plek + 1 : plek] || null);
      }
      if (hadFocus) {
        const knop = el.querySelector('[data-swatch-edit]');
        if (knop) knop.focus();
      }
    }

    function meldFout() {
      const drawer = SentirCart.drawer;
      if (drawer) drawer.announce('The colour could not be changed. Please check your cart.');
    }

    let nieuweSleutel = null;
    return vraag(ROUTES.add, { items: [{ id: variantId, quantity: quantity, properties: properties }] })
      .then((toegevoegd) => {
        const item = toegevoegd && toegevoegd.items && toegevoegd.items[0];
        nieuweSleutel = item ? item.key : null;
        return vraag(ROOT + 'cart.js');
      })
      .then((cart) => {
        // De oude regel: zelfde variant, zelfde kenmerken. Shopify voegt zulke regels samen, dus hij is uniek.
        const oud = (cart.items || []).find(
          (item) => Number(item.variant_id) === oldVariantId && zelfdeKenmerken(item.properties, properties)
        );
        if (!oud) return SentirCart.refresh();
        return vraag(ROUTES.change, metHtml({ id: oud.key, quantity: Math.max(0, oud.quantity - quantity) })).then((data) => {
          if (!data || !data.sections) return SentirCart.refresh();
          renderSections(data.sections);
          // na het weghalen kan de sleutel van de nieuwe regel weer verschoven zijn (korting): zoek hem op variant
          const nieuw = (data.items || []).find(
            (item) => Number(item.variant_id) === variantId && zelfdeKenmerken(item.properties, properties)
          );
          terugOpZijnPlek(nieuw ? nieuw.key : nieuweSleutel);
          return data;
        });
      })
      .catch(() => {
        meldFout();
        return SentirCart.refresh().catch(() => {});
      })
      .finally(() => {
        wisselBezig = false;
      });
  }

  /*
   * Kleurbolletjes op een regel. Dicht: alleen de gekozen kleur en "Change colour". Open: de andere kleuren schuiven
   * naar buiten (CSS). Een andere kleur kiezen klapt het weer in en wisselt de regel; dezelfde kleur klapt alleen in.
   * Klik ergens anders of Escape klapt ook in (Escape sluit dan niet meteen het hele mandje).
   */
  function closeSwatches(except) {
    document.querySelectorAll('[data-line-swatch].is-open').forEach((swatch) => {
      if (swatch === except) return;
      swatch.classList.remove('is-open');
      const edit = swatch.querySelector('[data-swatch-edit]');
      if (edit) edit.setAttribute('aria-expanded', 'false');
    });
  }

  function openSwatch(swatch) {
    closeSwatches(swatch);
    swatch.classList.add('is-open');
    const edit = swatch.querySelector('[data-swatch-edit]');
    if (edit) edit.setAttribute('aria-expanded', 'true');
    const gekozen = swatch.querySelector('[data-swatch-variant].is-selected');
    if (gekozen && edit && edit === document.activeElement) gekozen.focus();
  }

  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('[data-line-swatch]');
    if (!swatch) {
      closeSwatches();
      return;
    }
    if (swatch.classList.contains('is-busy') || wisselBezig) return;

    if (event.target.closest('[data-swatch-edit]')) {
      if (swatch.classList.contains('is-open')) closeSwatches();
      else openSwatch(swatch);
      return;
    }

    const dot = event.target.closest('[data-swatch-variant]');
    if (!dot || dot.disabled) return;
    if (!swatch.classList.contains('is-open')) {
      openSwatch(swatch);
      return;
    }
    const chosen = dot.dataset.swatchVariant;
    swatch.querySelectorAll('[data-swatch-variant]').forEach((other) => {
      const on = other === dot;
      other.classList.toggle('is-selected', on);
      other.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    closeSwatches();
    if (Number(chosen) !== Number(swatch.dataset.variantId)) {
      // Meteen de foto van de nieuwe kleur; het mandje rekent intussen op de achtergrond.
      const row = swatch.closest('.cd-item');
      const img = row && row.querySelector('.cd-item__media img');
      if (img && dot.dataset.image) {
        img.src = dot.dataset.image;
        img.srcset = dot.dataset.image2x ? dot.dataset.image + ' 1x, ' + dot.dataset.image2x + ' 2x' : '';
      }
      swapLineVariant(swatch, chosen);
    } else {
      const edit = swatch.querySelector('[data-swatch-edit]');
      if (edit && swatch.contains(document.activeElement)) edit.focus();
    }
  });

  // Escape met een open kleurkiezer: alleen de kiezer dicht. De drawer sluit op keyup; die vangen we hier in de
  // capture-fase af, zodat de klant niet in één keer het hele mandje kwijt is.
  let escapeVoorKiezer = false;
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const open = document.querySelector('[data-line-swatch].is-open');
    escapeVoorKiezer = Boolean(open);
    if (!open) return;
    const edit = open.querySelector('[data-swatch-edit]');
    closeSwatches();
    if (edit) edit.focus();
  });
  document.addEventListener(
    'keyup',
    (event) => {
      if (event.key === 'Escape' && escapeVoorKiezer) {
        escapeVoorKiezer = false;
        event.stopPropagation();
      }
    },
    true
  );

  /*
   * Duurzame opties onder "More options": elk vinkje is een kenmerk van het mandje dat met de bestelling meegaat
   * (zie /Users/thomas/Sentir/pakbon-duurzaam voor de pakbon). Opslaan zonder het mandje opnieuw op te bouwen, net als
   * de notitie, behalve bij "No twistcapsules added": dat verandert wat het mandje aanbiedt (geen cadeaublok en geen
   * capsulekaart), dus dan wel opnieuw opbouwen. Liggen er dan capsules in het mandje, dan zet Liquid de vraag
   * "capsules verwijderen?" open. Uitvinken stuurt een lege waarde, dan haalt Shopify het kenmerk weg.
   */
  document.addEventListener('change', (event) => {
    const vinkje = event.target.closest('[data-sustain-attr]');
    if (!vinkje) return;
    const paneel = vinkje.closest('[data-cart-tool-panel]');
    const status = paneel ? paneel.querySelector('[data-note-status]') : null;
    const gewenst = vinkje.checked;
    const kenmerken = { [vinkje.dataset.sustainAttr]: gewenst ? 'Yes' : '' };
    const zetStatus = (tekst) => {
      const s = document.querySelector('[data-cart-tool-panel="note"] [data-note-status]');
      if (s) s.textContent = tekst;
    };

    if (vinkje.dataset.capsuleKeys !== undefined) {
      SentirCart.update({ attributes: kenmerken })
        .then((data) => {
          if (!data || data.status) throw new Error('save');
          zetStatus('Saved');
        })
        .catch(() => {
          const opnieuw = document.querySelector('[data-capsule-keys]');
          if (opnieuw) opnieuw.checked = !gewenst;
          zetStatus('Could not save');
        });
      return;
    }

    fetch(ROUTES.update + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest', [OWN_REQUEST_HEADER]: '1' },
      body: JSON.stringify({ attributes: kenmerken }),
    })
      .then((response) => {
        if (!response.ok) throw new Error('save');
        if (status) status.textContent = 'Saved';
      })
      .catch(() => {
        vinkje.checked = !gewenst;
        if (status) status.textContent = 'Could not save';
      });
  });

  /*
   * Antwoord op "capsules verwijderen?". Ja: alle capsuleregels in één keer weg (de optie blijft aan). Nee: de klant
   * houdt de capsules, dus "No twistcapsules" past niet meer: de optie gaat uit, anders staat er op de pakbon
   * "GEEN twistcapsules meesturen" terwijl er capsules in de bestelling zitten. Eén verzoek dat ook opnieuw opbouwt.
   */
  document.addEventListener('click', (event) => {
    const ja = event.target.closest('[data-sustain-remove]');
    const nee = event.target.closest('[data-sustain-keep]');
    if (!ja && !nee) return;
    const vraag = event.target.closest('[data-sustain-confirm]');
    const paneel = event.target.closest('[data-cart-tool-panel]');
    const vinkje = paneel ? paneel.querySelector('[data-capsule-keys]') : null;
    if (nee) {
      if (vraag) vraag.hidden = true;
      if (vinkje) vinkje.checked = false;
      SentirCart.update({ attributes: { [vinkje ? vinkje.dataset.sustainAttr : 'Sustainable: no twistcapsules']: '' } });
      return;
    }
    const sleutels = vinkje ? (vinkje.dataset.capsuleKeys || '').split(',').filter(Boolean) : [];
    if (!sleutels.length) return;
    const updates = {};
    sleutels.forEach((sleutel) => {
      updates[sleutel] = 0;
    });
    if (vraag) vraag.hidden = true;
    SentirCart.update({ updates: updates })
      .then((data) => {
        if (!data || data.status) throw new Error('remove');
      })
      .catch(() => {
        const opnieuw = document.querySelector('[data-sustain-confirm]');
        if (opnieuw) opnieuw.hidden = false;
      });
  });

  /* Kleurbolletjes in een aanbodkaart: kleur kiezen, foto wisselt mee. Toevoegen doet de knop "Add" ernaast. */
  document.addEventListener('click', (event) => {
    const bol = event.target.closest('[data-pick-variant]');
    if (bol) kiesBol(bol);
  });

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-gift-variant], [data-capsule-variant], [data-upsell-variant]');
    if (!select) return;

    const block = select.closest('.cd-gift, .cd-capsule');
    const image = block && block.querySelector('[data-gift-image], [data-capsule-image]');
    const option = select.options[select.selectedIndex];
    if (!image || !option || !option.dataset.variantImage) return;

    image.src = option.dataset.variantImage;
    image.srcset = option.dataset.variantImageRetina
      ? option.dataset.variantImage + ' 1x, ' + option.dataset.variantImageRetina + ' 2x'
      : '';

    // Zonder dit blijft de omschrijving bij de vorige kleur staan.
    if (option.dataset.variantImageAlt !== undefined) {
      image.alt = option.dataset.variantImageAlt;
    }
  });
})();
